import React from 'react';
import { withRouter } from 'react-router';
import { makeStyles, Container, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

import Divide from '../../reusable/Divide';

////////// COMPONENT //////////
function LanesSearch(props) {
  const cls = useStyles();

  const options = props.lanes.map(option => {
    const firstLetter = option && option.description ? option.description[0].toUpperCase() : `_`;
    return { firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter, ...option }
  });

  const handleChange = (event, value) => {
    if (value) props.history.push(`/lanes/${value.id}`);
  }

  return (
    <div className={cls.backdrop}>
      <Container maxWidth="md">
        <Divide color="white" smallSpacer>Search</Divide>
        <div className={cls.hold}>
          <Autocomplete
            id="lanes-autosuggest"
            options={options.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
            groupBy={option => option.firstLetter}
            getOptionLabel={option => option.description}
            getOptionSelected={option => option}
            className={cls.autocomplete}
            renderInput={params => (<TextField {...params} label="" placeholder="Search for a lane..." variant="outlined" margin="dense" style={{ margin: 0 }} fullWidth />)}
            onChange={handleChange}
            disablePortal={true}
          />
        </div>
      </Container>
    </div>
  )
}

////////// EXPORT //////////
export default withRouter(LanesSearch);

////////// STYLES //////////
const useStyles = makeStyles(theme => ({
  backdrop: {
    position: 'relative',
    width: '100%',
    paddingBottom: theme.spacing(2),
    backgroundImage: `linear-gradient(${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
  },
  hold: {
    borderRadius: theme.shape.borderRadius,
    background: theme.palette.background.paper,
  },
}));